module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Reset Password","alert":{"success":"An email has been sent to {email} with further instructions."}}}')
  delete Component.options._Ctor
}
